module.exports = __webpack_public_path__ + "static/media/lawn2.e80bbe85.jpg";